// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2Bk5u{color:#3f9fff;font-weight:400;text-decoration:underline}", ""]);
// Exports
exports.locals = {
	"email": "_2Bk5u"
};
module.exports = exports;
